import React, { Component } from 'react';
import axios from 'axios';
import $ from "jquery";
class ContactUsInfo extends Component {
  constructor() {
    super();
    this.save_free_consulting = this.save_free_consulting_data.bind(this);
    this.state = {
      send_button : <button className="btn btn-primary w-100 py-3" type="button" onClick={this.save_free_consulting}>Send Message</button>,
    };
  }

  componentDidMount() {

  }

  save_free_consulting_data(){
    let cutThis         = this;
    var send_button     = <button className="btn btn-primary w-100 py-3" type="button">Sending...</button>;
    cutThis.setState({send_button});
    $('label').removeClass('color_red');
    var name            = window.isNullAndUndef($('#name').val());
    var email           = window.isNullAndUndef($('#email').val());
    var subject         = window.isNullAndUndef($('#subject').val());
    var message         = window.isNullAndUndef($('#message').val());
    var web_token       = window.isNullAndUndef($('#web_token').val());
    var email_validate  = window.validateEmail($('#email').val());
    if(name && email && subject && message && email_validate && message.length<=250 && web_token){
      var body = new FormData();
      body.append('name',name);
      body.append('email',email);
      body.append('subject',subject);
      body.append('message',message);
      body.append('web_token',web_token);
      body.append('function','send_contact_us');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/contact_us.php";
      }else{
        url = "/php/contact_us.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          console.log(data);
          var msg = data['msg'];
          if(data['code']==1){
            $('#error_msg').text(msg).addClass('hide');
          }else{
            $('#error_msg').text(msg).addClass('hide').addClass('color_red');
          }
          send_button     = <button className="btn btn-primary w-100 py-3" type="button">Send Message</button>;
          cutThis.setState({send_button});
        })
        .catch(function (error) {
            console.log(error);
        });
    }else{
      window.change_lable_color('name','email','subject','message');
      send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.save_free_consulting}>Send Message</button>;
      cutThis.setState({send_button});
    }
    setTimeout(function () {$('#error_msg').text('').addClass('hide').removeClass('color_red');}, 20000);
  }
  render() {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <h1 className="text-start mb-2 wow fadeInUp" data-wow-delay="0.1s">Corporate Office</h1>
                <div className="row g-4">
                    <div className="col-12">
                        <div className="row gy-4">
                            <div className="col-md-4 wow fadeIn" data-wow-delay="0.1s">
                                <div className="d-flex align-items-center bg-light rounded p-4">
                                    <div className="rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3 width-height-45">
                                        <i className="fa fa-map-marker-alt text-primary"></i>
                                    </div>
                                    <span>Unit No. 3106 , 3rd Floor, Wing- W,  Akshar business park, Janta Market Rd, opposite APMC Fruits and Vegetable Market, Sector 25, Vashi, Navi Mumbai, Maharashtra 400703</span>
                                </div>
                            </div>
                            <div className="col-md-4 wow fadeIn" data-wow-delay="0.3s">
                                <div className="d-flex align-items-center bg-light rounded p-4">
                                    <div className="rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3 width-height-45">
                                        <i className="fa fa-envelope-open text-primary"></i>
                                    </div>
                                    <span>Info@bylawslegal.com</span>
                                </div>
                            </div>
                            <div className="col-md-4 wow fadeIn" data-wow-delay="0.5s">
                                <div className="d-flex align-items-center bg-light rounded p-4">
                                    <div className="rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3 width-height-45">
                                        <i className="fa fa-phone-alt text-primary"></i>
                                    </div>
                                    <span>+91-7738789456</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 mb-5">
                      <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                          <iframe className="position-relative rounded w-100 h-100 map-div"
                              src="https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1sAkshar+business+park,+Janta+Market+Rd+opposite+APMC+Fruits+and+Vegetable+Market+Sector+25+Vashi!6i20"

                              frameborder="0" allowfullscreen="" aria-hidden="false"
                              tabindex="0"></iframe>
                      </div>
                      <div className="col-md-6 row g-4">
                          <div className="wow fadeInUp" data-wow-delay="0.5s">
                              <form method="post" action="." name="Contact">
                                  <div className="row g-3">
                                      <div className="col-md-6">
                                          <div className="form-floating">
                                              <input type="text" className="form-control" id="name" name="name" placeholder="Your Name"/>
                                              <label for="name">Your Name</label>
                                          </div>
                                      </div>
                                      <div className="col-md-6">
                                          <div className="form-floating">
                                              <input type="email" className="form-control" id="email" name="email" placeholder="Your Email"/>
                                              <label for="email">Your Email</label>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="form-floating">
                                              <input type="text" className="form-control" id="subject" name="subject" placeholder="Subject"/>
                                              <label for="subject">Subject</label>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="form-floating">
                                              <textarea className="form-control textarea-height" placeholder="Leave a message here" id="message" name="message" maxlength="250"></textarea>
                                              <label for="message">Message</label>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                      <p className="hide" id="error_msg"></p>
                                      {this.state.send_button}
                                      </div>
                                  </div>
                              </form>
                          </div>
                      </div>
                    </div>



                    <div className="col-12">
                    <h1 className="text-start mb-2 wow fadeInUp" data-wow-delay="0.1s">Other Locations</h1>
                        <div className="row gy-4">
                            <div className="col-md-3 wow fadeIn" data-wow-delay="0.1s">
                                <div className="d-flex align-items-center bg-light rounded p-4">
                                    <div className="rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3 width-height-45">
                                        <i className="fa fa-map-marker-alt text-primary"></i>
                                    </div>
                                    <span>Delhi/NCR</span>
                                </div>
                            </div>
                            <div className="col-md-3 wow fadeIn" data-wow-delay="0.3s">
                                <div className="d-flex align-items-center bg-light rounded p-4">
                                    <div className="rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3 width-height-45">
                                        <i className="fa fa-map-marker-alt text-primary"></i>
                                    </div>
                                    <span>GIFT CITY</span>
                                </div>
                            </div>
                            <div className="col-md-3 wow fadeIn" data-wow-delay="0.5s">
                                <div className="d-flex align-items-center bg-light rounded p-4">
                                    <div className="rounded d-flex flex-shrink-0 align-items-center justify-content-center me-3 width-height-45">
                                        <i className="fa fa-map-marker-alt text-primary"></i>
                                    </div>
                                    <span>Katihar</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
  }
}

export default ContactUsInfo;
